import { render, staticRenderFns } from "./SubscribeList.vue?vue&type=template&id=0020ccd0&"
import script from "./SubscribeList.vue?vue&type=script&lang=js&"
export * from "./SubscribeList.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeList.vue?vue&type=style&index=0&id=0020ccd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports